import React, {Component} from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import ActionSave from 'material-ui/svg-icons/content/save';
import ActionCopy from 'material-ui/svg-icons/content/content-copy';
import ActionPaste from 'material-ui/svg-icons/content/content-paste';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';
import {DivHeaderActions, DivTitle, DivContent } from './styled';
import Paper from 'material-ui/Paper';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import { DialogIconTemplate, TextInput, Alignment, BlockCounter } from './components';
import {SketchColorPicker}  from '../../../components';


class FAButtonView extends Component{
  constructor(props){
    super(props);
    const { buttonColors, icon, mini, zDepth, href, buttonAlign , disabled, containerPadding} = props.data.values;
    this.state = {
      expanded: true,
      buttonColors, 
      icon, 
      zDepth, 
      href, 
      mini,
      buttonAlign, 
      disabled, 
      containerPadding
    }
  }
  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  }
  
  onUpdateUrl = (value) => {
    let newHref = this.state.href;
    newHref.url = value;
    
    this.setState({
      href: newHref,
    });
  }
  onItemSelected = (value) => {
    this.setState({
      icon: value,
    });
  }  
  
  onChangeButtonAlign = (value) => {
    this.setState({
      buttonAlign: value,
    });
  }
  onToggleDisabled = (e,v) => {
    this.setState({disabled:v});
  }
  onToggleMini = (e,v) => {
    this.setState({mini:v});
  }
  onChangeTarget = (event, index, value) => {
    const newValue = (value === '_blank') ? value : '';
    let newHref = this.state.href;
    newHref.target = newValue;
    this.setState({
      href: newHref,
    });
  }
  
  onChangeZDepth = (event, index, value) => {
    this.setState({
      zDepth: value,
    });
  }
  onUpdatePadding = (padding) => {
    this.setState({containerPadding:padding});
  }
  onUpdateColor = (color, type ) => {
    let newButtonColor = this.state.buttonColors;
    if(type === 'color'){
      newButtonColor.color = color;  
    } else if(type === 'background'){
      newButtonColor.backgroundColor = color;  
    } else if(type === 'hover'){
      newButtonColor.hoverColor = color;
    } else if(type === 'disabled'){
      newButtonColor.disabledColor = color;
    }
    this.setState({
      buttonColors: newButtonColor,
    });
  }
   
  
  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.buttonAlign = this.state.buttonAlign;
    newData.values.buttonColors = this.state.buttonColors;
    newData.values.icon = this.state.icon;
    newData.values.disabled = this.state.disabled;
    newData.values.href = this.state.href;
    newData.values.zDepth = this.state.zDepth;
    newData.values.mini = this.state.mini;
    localStorage.setItem('FAButtonView', JSON.stringify(newData.values));
  }
  onClickPaste = () => {
    const FABContent = JSON.parse(localStorage.getItem('FAButtonView'));
    if(FABContent){
      const { buttonColors, mini, icon, href, buttonAlign , zDepth, disabled, containerPadding} = FABContent;
      this.setState({
        buttonColors, 
        icon, 
        zDepth, 
        href, 
        mini,
        buttonAlign, 
        disabled, 
        containerPadding
      });
    }
  }
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.buttonAlign = this.state.buttonAlign;
    newData.values.buttonColors = this.state.buttonColors;
    newData.values.icon = this.state.icon;
    newData.values.disabled = this.state.disabled;
    newData.values.href = this.state.href;
    newData.values.zDepth = this.state.zDepth;
    newData.values.mini = this.state.mini;
    //  console.log(newData.values);
    this.props.onUpdateData(newData);
  }
  render(){
    const {target} = this.state.href;
    const valueTarget = (target === '_blank') ? target : 'same';
    return(
      <div style={{width:'100%'}}>
        <div style={styles.paperCard}>
          <Card expanded={this.state.expanded} onExpandChange={this.handleExpandChange}> >
            <CardHeader
              title="General"
              subtitle="Content Floating Action Button"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText expandable={true} style={{ overflowY: "scroll", height: 500 }}>
              <Paper style={styles.paperText} zDepth={1}>
                <div>
                  <Toggle
                    label="Disabled FAB Button"
                    style={{marginBottom:10}}
                    toggled={this.state.disabled}
                    onToggle={(e,v) =>this.onToggleDisabled(e,v)}
                  />
                </div>
                <div>
                  <Toggle
                    label="Mini Button"
                    style={{marginBottom:10}}
                    toggled={this.state.mini}
                    onToggle={(e,v) =>this.onToggleMini(e,v)}
                  />
                </div>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>zDepth FAB Button</DivTitle>
                <SelectField floatingLabelText="" onChange={(event, index, value) => this.onChangeZDepth(event, index, value)} value={this.state.zDepth} autoWidth={true} name="zDepth" >
                  <MenuItem value={1} primaryText="1" />
                  <MenuItem value={2} primaryText="2" />
                  <MenuItem value={3} primaryText="3" />
                  <MenuItem value={4} primaryText="4" />
                  <MenuItem value={5} primaryText="5" />
                </SelectField>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Button Align</DivTitle>
                <Alignment value={this.state.buttonAlign} onChange={(value) => this.onChangeButtonAlign(value)} title=""/>
              </Paper>
              <Paper style={{padding:10, marginBottom:10}} zDepth={1}>
                <DivTitle>Button Color</DivTitle>
                <DivContent>
                  <SketchColorPicker title={'Color'} onUpdateColor={(color) => this.onUpdateColor(color,'color')} color={this.state.buttonColors.color}/>
                  <SketchColorPicker title={'Background'} onUpdateColor={(color) => this.onUpdateColor(color,'background')} color={this.state.buttonColors.backgroundColor}/>
                  <SketchColorPicker title={'Hover'} onUpdateColor={(color) => this.onUpdateColor(color, 'hover')} color={this.state.buttonColors.hoverColor}/>
                  <SketchColorPicker title={'Disabled'} onUpdateColor={(color) => this.onUpdateColor(color, 'disabled')} color={this.state.buttonColors.disabledColor}/>
                </DivContent>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Action</DivTitle>
                <TextInput value={this.state.href.url} onChange={(value) => this.onUpdateUrl(value)} name="HrefUrl" title="Url" fullWidth={true}/>
                <SelectField floatingLabelText="Target" onChange={(event, index, value) => this.onChangeTarget(event, index, value)} value={valueTarget} autoWidth={true} name="target href" >
                  <MenuItem value={'same'} primaryText="Same Page" />
                  <MenuItem value={'_blank'} primaryText="New Page" />
                </SelectField>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DialogIconTemplate iconItem={this.state.icon} onItemSelected={(icon) => {this.onItemSelected(icon)}} isRequired={true} />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter containerPadding={this.state.containerPadding} onUpdatePadding={(containerPadding) => this.onUpdatePadding(containerPadding)}  />
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton onClick={this.onClickCopy} iconStyle={{color:'#FFFFFF'}} >
            <ActionCopy/>
          </IconButton>
          <IconButton onClick={this.onClickPaste} iconStyle={{color:'#FFFFFF'}} >
            <ActionPaste/>
          </IconButton>
          <IconButton onClick={this.onClickSave} iconStyle={{color:'#FFFFFF'}} >
            <ActionSave/>
          </IconButton>
        </DivHeaderActions>
      </div>
    )
  }
}
 

const styles = {
  paper: {
    margin:10,
    padding:10
  },
  headerCard: {
    display:'flex',
    textAlign:'left'
  },
  paperCard:{
    margin:10
  },
  paperText: {
    padding:10,
    marginBottom:10
  },
  customWidth: {
    width: 150,
  },
  block: {
    maxWidth: 250,
  },
  radioButton: {
    width: 136
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent:'flex-start',
    flex: '1 auto'
  }
}

FAButtonView.propTypes = {
  data: PropTypes.object,
  onUpdateData : PropTypes.func.isRequired
};

FAButtonView.defaultProps = {
  data:{}
};
export default FAButtonView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/FAButtonView.js